import { Box, Grid2, TextField, Typography } from "@mui/material"
import { CollapsibleCard } from "components/CollapsiblCard/CollapsibleCard"
import { DeviceEutGroup, User } from "graphql/types"
import { useStoreActions, useStoreState } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { emptyPerson } from "store/store"
import { formatDateTime } from "utils/dateTimeUtils"
import { useLocalStorage } from "utils/useLocalStorage"
import { v4 } from "uuid"
import { CardActionButton } from "./CardActionButton"

type EUTNotesCollapsibleProps = {
  eut: DeviceEutGroup
  onSave: (arg: DeviceEutGroup) => void
}

export const EUTNotesCollapsible = (props: EUTNotesCollapsibleProps) => {
  const { eut, onSave } = props
  const [currentUser] = useLocalStorage<User>("user", emptyPerson)
  const [isEdit, setIsEdit] = useState(false)
  const { users } = useStoreState((state) => state)

  const { fetchUsers } = useStoreActions((actions) => actions)

  useEffect(() => {
    const loadUsers = async () => {
      try {
        await fetchUsers({ fresh: false })
      } catch (err) {
        console.error("Error loading users:", err)
      }
    }
    loadUsers()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleCancel = () => {
    setIsEdit(false)
  }

  const getDisplayName = (id: string) => {
    const user = users.find((user) => user.id === id)
    return user?.displayName ?? ""
  }

  const handleSave = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const formData = new FormData(event.currentTarget)
    const updatedEut: DeviceEutGroup = {
      ...eut,
      notes: [
        ...eut.notes,
        {
          id: v4(),
          note: (formData.get("note") as string) ?? "",
          createdBy: currentUser.id,
          createdAt: new Date().toISOString(),
        },
      ],
    }
    onSave(updatedEut)
    setIsEdit(false)
  }

  return (
    <CollapsibleCard
      open={false}
      title="Notizen"
      cardActions={
        <CardActionButton
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          handleCancel={handleCancel}
          form="formNote"
        />
      }
    >
      <Grid2
        container
        spacing={2}
        sx={{ padding: 1 }}
        component="form"
        onSubmit={handleSave}
        id="formNote"
      >
        {eut.notes.map((note) => (
          <Grid2 size={12} key={note.id}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="caption">
                {formatDateTime(note.createdAt)}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Typography variant="caption">
                  {`${getDisplayName(note.createdBy)}`}
                </Typography>
              </Box>
            </Box>
            <Typography>{note.note}</Typography>
          </Grid2>
        ))}

        {isEdit && (
          <Grid2 size={12}>
            <TextField
              size="small"
              name="note"
              disabled={!isEdit}
              fullWidth
              label="Neue Notiz"
            />
          </Grid2>
        )}
      </Grid2>
    </CollapsibleCard>
  )
}
